// CONST  / VARIABLES
const header = document.querySelector(".header--spe");
const itemMenu = header.querySelectorAll(".menu-level-0 > .menu-item");
const headerTop = document.querySelector(".header--spe__top");
const headerBottom = document.querySelector(".header--spe__bottom");
let breakpoint = bsBreakpoints.detectBreakpoint();
const headerMenu = document.querySelector(".menu-level-0") || null;

/**
 * @description Fonction refactoriser structure / style des submenus
 */

const refactoSubMenu = () => {
  const headerWidth = header.offsetWidth;
  const headerTopWidth = headerTop.offsetWidth;
  if (breakpoint === "large" || breakpoint === "xLarge") {
    itemMenu.forEach((item) => {
      const itemSubMenu = item.querySelector(".menu-dropdown-0") || null;
      // set element to left of screen
      let calculLeft;
      if (header.classList.contains("header--spe--scrolled")) {
        calculLeft = item.offsetLeft + headerTopWidth;
      } else {
        calculLeft = item.offsetLeft;
      }

      if (itemSubMenu) {
        itemSubMenu.style.left = -calculLeft + "px";
        itemSubMenu.style.width = headerWidth + "px";
      }
    });
  }
};

/**
 * @description Fonction Menu responsive
 */

const respMenu = () => {
  const headerMenu = document.querySelector(".header__desktop__menu");
  const menuItem = document.querySelectorAll(".menu-item");
  const btnShorcuts =
    document.querySelectorAll(".submenu__shortcuts__btn") || null;

  //création btn
  if (!header.querySelector(".btn-prev-link")) {
    const btnPrev = document.createElement("button");
    btnPrev.classList.add("btn-prev-link");
    btnPrev.setAttribute("title", "Revenir au menu précédent");
    header ? header.querySelector("nav").appendChild(btnPrev) : "";
  }
  // listener click sur le btn
  const btnLink = document.querySelector(".btn-prev-link") || null;

  if (btnLink) {
    btnLink.addEventListener("click", () => {
      //on check le dernier sous menu ouvert
      const submenuVisible = document.querySelectorAll(".menu-dropdown--open");
      const lastEl = submenuVisible[submenuVisible.length - 1];

      const subMenuShortcut =
        document.querySelector(".submenu__shortcuts--open") || null;
      if (subMenuShortcut) {
        // on close le shortcut et on vide le btn prev
        subMenuShortcut.classList.remove("submenu__shortcuts--open");
        const txt = btnLink.getAttribute("data-title");
        btnLink.textContent = txt;
        btnLink.setAttribute("data-title", "");
      } else if (submenuVisible.length === 1) {
        // Si on est sur le premier sous menu on cache le menu  et on enleve le btn
        document.querySelectorAll(".menu-dropdown-0").forEach((dropdown) => {
          dropdown.classList.remove("menu-dropdown--open");
        });
        btnLink.textContent = "";
        btnLink.classList.remove("btn-prev-link--visible");
      } else {
        // On passe au menu précédent
        lastEl.classList.remove("menu-dropdown--open");
        btnLink.textContent =
          lastEl.parentNode.parentNode.parentNode.parentNode.querySelector(
            ".menu-item__link"
          ).innerText;
      }
    });
  }
  // Gestion des liens des shortcuts
  if (btnShorcuts) {
    btnShorcuts.forEach((btn) => {
      btn.addEventListener("click", () => {
        btn.parentNode.classList.add("submenu__shortcuts--open");
        const btnLink = document.querySelector(".btn-prev-link") || null;
        const txt = btn.parentNode.querySelector(
          ".submenu__shortcuts__title"
        ).innerText;
        btnLink.innerText = txt;
      });
    });
  }

  if (
    breakpoint === "xSmall" ||
    breakpoint === "small" ||
    breakpoint === "medium"
  ) {
    const menuResp = document.querySelector(".menu-level-0 ");

    // Manipulation de position pour palier a la position absolute obligatoire des sous menus (position fixed pose des soucis au niveau du scroll)
    // Pour les submenus de premier niveau, on boucle et multiplie la hauteur d'un element par son index et on set le resultat en top
    const dropdown0 = document.querySelectorAll(".menu-dropdown-0");

    menuResp.appendChild(headerBottom);
  }

  menuItem.forEach((item) => {
    // On gère le click des sous menus et leur affichage
    const btnLvl0 = item.querySelector(".menu-item__btn-0") || null;
    const btnLvl1 = item.querySelector(".menu-item__btn-1") || null;

    const detectBtn = (level) => {
      const btn = item.querySelector(`.menu-item__btn-${level}`) || null;

      btn.addEventListener("click", () => {
        const btnLink = document.querySelector(".btn-prev-link");
        btnLink.classList.add("btn-prev-link--visible");
        document
          .querySelectorAll(`.menu-dropdown-${level}`)
          .forEach((dropdown) => {
            dropdown.classList.remove("menu-dropdown--open");
          });
        item
          .querySelector(`.menu-dropdown-${level}`)
          .classList.add("menu-dropdown--open");

        const textLink = item.querySelector(".menu-item__link").innerText;
        btnLink.textContent = textLink;
        btnLink.setAttribute("data-title", textLink);
      });
    };

    //Gestion sous menu lvl 1
    if (btnLvl0) {
      detectBtn(0);
    }
    //Gestion sous menu lvl 2
    else if (btnLvl1) {
      detectBtn(1);
    }
  });
  // Move menu if rtab/mobile
  if (
    breakpoint === "xSmall" ||
    breakpoint === "small" ||
    breakpoint === "medium"
  ) {
    header ? header.insertAdjacentElement("afterbegin", headerMenu) : "";
  }
};

/**
 * @description Fonction pour toggle le menu
 */
const toggleMenu = () => {
  if (
    breakpoint === "xSmall" ||
    breakpoint === "small" ||
    breakpoint === "medium"
  ) {
    const btnMenu = document.querySelector(".header__menu__toggle");
    btnMenu.addEventListener("click", () => {
      // Si menu open on ferme tout
      if (header.classList.contains("header--open")) {
        const prevLink = document.querySelector(".btn-prev-link") || null;
        if (prevLink) {
          prevLink.classList.remove("btn-prev-link--visible");
        }
        document.querySelectorAll(".menu-dropdown").forEach((item) => {
          if (item.classList.contains("menu-dropdown--open")) {
            item.classList.remove("menu-dropdown--open");
            document
              .querySelectorAll(".submenu__shortcuts")
              .forEach((shortcut) => {
                shortcut.classList.remove("submenu__shortcuts--open");
              });
          }
        });
      }
      //Sinon on déplie le menu
      document.querySelector("body").classList.toggle("overflow-hidden");
      header.classList.toggle("header--open");
      btnMenu.classList.toggle("header__menu__toggle--open");
      headerTop.classList.toggle("header--spe__top--open");
      headerBottom.classList.toggle("header--spe__bottom--open");
      setTimeout(() => {
        headerMenu.classList.toggle("menu-level-0--open");
      }, 200);
    });
  }
};

/**
 * @description Fonction refactoriser structure / style des shortcuts
 */
const refactoSubMenuShortcuts = () => {
  const headerShortcuts =
    header.querySelectorAll(".submenu__shortcuts") || null;
  // on ajoute les shortcuts au bloc du menu
  if (headerShortcuts) {
    headerShortcuts.forEach((shortcutsList) => {
      const dropdown =
        shortcutsList.parentNode.querySelector(".menu-dropdown") || null;
      if (dropdown) {
        dropdown.appendChild(shortcutsList);

        shortcutsList
          ? dropdown.classList.add("hasShortcut")
          : dropdown.classList.remove("hasShortcut");
      }
    });
  }
};

/**
 * @description Reprend le titre de 1er niveau du menu pour l'inclure dans son sous-menu
 */
const dataTitle = () => {
  const subMenu = document.querySelectorAll(".menu-dropdown-0") || null;

  subMenu.forEach((element) => {
    const title = element.parentElement.getAttribute("data-title");

    element.insertAdjacentHTML(
      "afterbegin",
      `<span class="menu-spe--title pratique" aria-hidden="true">${title}</span>`
    );
  });
};

/**
 *  @description Open/close menu démarches
 */
const toggleDemarches = () => {
  const toggle = document.querySelector("[data-demarches-toggle]") || null;
  const close = document.querySelector("[data-demarches-close]") || null;
  const demarches =
    document.querySelector(".header-demarches__container") || null;

  toggle.addEventListener("click", () => {
    if (breakpoint === "large" || breakpoint === "xLarge") {
      document.querySelector("body").classList.toggle("overflow-hidden");
    }
    demarches.classList.toggle("open");
    toggle.classList.toggle("btn-demarches-open");
  });

  close.addEventListener("click", () => {
    if (!demarches.classList.toggle("open")) {
      demarches.classList.remove("open");
      toggle.classList.remove("btn-demarches-open");

      if (breakpoint === "large" || breakpoint === "xLarge") {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
    }
  });
};

const toggleProfil = () => {
  const toggle = document.querySelector("[data-profil-toggle]") || null;
  const close = document.querySelector("[data-profil-close]") || null;
  const profil = document.querySelector(".header-profil__container") || null;

  toggle.addEventListener("click", () => {
    profil.classList.toggle("open");
  });

  close.addEventListener("click", () => {
    if (!profil.classList.toggle("open")) {
      profil.classList.remove("open");
    }
  });
};

const init = () => {
  if (header) {
    window.addEventListener("load", () => {
      refactoSubMenuShortcuts();
      respMenu();
      toggleMenu();
      dataTitle();
      toggleDemarches();
      toggleProfil();
    });

    window.addEventListener("resize", () => {
      setTimeout(() => {
        breakpoint = bsBreakpoints.detectBreakpoint();
        respMenu();
      }, 500);
    });
  }
};

init();
